<span class="badge {{ 'badge--' + variant }}">{{ text }}</span>
